module.exports = __webpack_public_path__ + "img/symbol_5.27e56ef1.png";